import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const employeeListService = (data: any) => {
  return axiosInstance
    .get(`${ENDPOINTS.ADMIN.EMPLOYEE_MANAGEMENT.READ_LIST}?${data}`)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
